
import { BaggingController } from "@/app/ui/controllers/BaggingController";
import { Options, Vue } from "vue-class-component";
import moment from "moment";

@Options({
  props: {
    baggingDisputeSummaryData: {
      default: {
        startDate: "",
        endDate: "",
        totalBaggingDispute: 0,
        totalBaggingData: 0,
        totalPercentage: 0
      },
      type: Object
    },
    currentStartDate: {
      type: Date  
    },
    currentEndDate: {
      type: Date 
    }
  }
})

// using class component
export default class DisputeSummary extends Vue {
  downloadExcel() {
    BaggingController.downloadDisputeSummary();
  }

  formatDate(date: string) {
    return moment(date).format("DD MMM");
  }
}
